/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Flex,
  Image,
  Space,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import logoMini from 'src/assets/image/logo-mini.svg';

function ClpUpdate() {
  const [colorMode, setColorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const [urlSearchParams] = useSearchParams();
  //have been encode auto
  const redirectUrl = urlSearchParams.get('redirect') || '';
  // if (
  //   redirectUrl !== '' &&
  //   !redirectUrl.includes('https://') &&
  //   !redirectUrl.includes('http://')
  // ) {
  //   redirectUrl = `https://${redirectUrl}`;
  // }

  useEffect(() => {
    setColorMode('light');
  }, []);

  return (
    <Box
      position="relative"
      height="100vh"
      width="100vw"
      backgroundColor={colorStyle.background.secondary}
    >
      <Header />
      <Flex
        border="1px solid"
        borderColor={colorStyle.background.tertiary}
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        p="32px 40px 32px 40px"
        height="40vh"
        width="30vw"
        direction="column"
        backgroundColor={colorStyle.background.primary}
        color={colorStyle.color.emphasis}
      >
        <Text fontSize="24px">Update your account</Text>
        <Space height="8%" />
        <Text>
          Your business has updated to Trend Vision One Email and Collaboration
          Security and requires that you update your account.
        </Text>
        <Space height="12%" />
        <Text>
          After the update, your current Cloud App Security console is no longer
          available.
        </Text>
        <Space height="20%" />
        <div style={{ display: 'flex', alignSelf: 'center' }}>
          <Button
            variant="emphasis"
            onClick={() => {
              window.open(redirectUrl, '_self');
            }}
          >
            Continue
          </Button>
        </div>
      </Flex>
      <Footer />
    </Box>
  );
}

const Header = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  return (
    <Box
      borderBottom="1px solid"
      borderBottomColor={colorStyle.background.tertiary}
      height="60px"
      position="absolute"
      top="0"
      left="0"
      width="100%"
      backgroundColor={colorStyle.background.primary}
      display="flex"
      alignItems="center"
    >
      <Image src={logoMini} height={28} ml="16px" />
      <Box
        ml="12px"
        fontSize="20px"
        lineHeight="28px"
        dangerouslySetInnerHTML={{
          __html: 'Trend Micro&trade; Cloud App Security',
        }}
      />
    </Box>
  );
};

const Footer = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  return (
    <Box
      borderTop="1px solid"
      borderTopColor={colorStyle.background.tertiary}
      height="48px"
      position="absolute"
      bottom="0"
      left="0"
      width="100%"
      backgroundColor={colorStyle.background.primary}
      display="flex"
      alignItems="center"
    >
      <Text
        ml="8px"
        fontSize="12px"
        dangerouslySetInnerHTML={{
          __html: `Copyright &copy; ${new Date().getFullYear()} Trend Micro Incorporated. All rights reserved.`,
        }}
      />
    </Box>
  );
};

export default ClpUpdate;
